const R = require('ramda');

module.exports = function (value) {
  return R.propOr('', 'portal_name', value);
};
